var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconLaunchbarAlignmentsViewer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24.8 14.5c0-3-2.6-3-4.8-3-2.3 0-3.8-.1-3.8-2h7v-3h-15v3h7c0 3 2.7 3 4.8 3 2.5 0 3.8.1 3.8 2h-4v3h9v-3z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.2 22.5c0-3-1.7-3-3-3-1.2 0-2 0-2-2h7v-3h-15v3h7c0 3 1.8 3 3 3s2 0 2 2h-7v3h15v-3z"
})));
export default SvgIconLaunchbarAlignmentsViewer;